export default "__VITE_PUBLIC_ASSET__96000c22__"